import {AppStore} from "../../desktop";
import {Employee} from "../../models/Employee";
import {EmployeesActionTypes} from "./types";
import {TabsActionTypes} from "../tabs";

export const actionEmployeeFetchAll = () => {
	AppStore.dispatch({type: EmployeesActionTypes.FETCH_ALL_REQUEST, payload: null})
}

export const actionEmployeeFetchAllCompleted = (employees: Employee[]) => {
	AppStore.dispatch({type: EmployeesActionTypes.FETCH_ALL_COMPLETED, payload: employees})
}

export const actionEmployeeFetch = (employee: Employee) => {
	AppStore.dispatch({type: EmployeesActionTypes.FETCH_ONE_REQUEST, payload: employee})
}

export const actionEmployeeFetchCompleted = (employee: Employee) => {
	AppStore.dispatch({type: EmployeesActionTypes.FETCH_ONE_COMPLETED, payload: employee})
	AppStore.dispatch({type: TabsActionTypes.SET_TAB_ITEM, payload: employee})
}

export const actionEmployeeSave = (employee: Employee) => {
	AppStore.dispatch({type: EmployeesActionTypes.SAVE_REQUEST, payload: employee})
}

export const actionEmployeeSaveCompleted = (employee: Employee) => {
	AppStore.dispatch({type: EmployeesActionTypes.SAVE_COMPLETED, payload: employee})
}

export const actionEmployeeDelete = (employee: Employee) => {
	AppStore.dispatch({type: EmployeesActionTypes.DELETE_REQUEST, payload: employee})
}

export const actionEmployeeDeleteCompleted = (employee: Employee) => {
	AppStore.dispatch({type: EmployeesActionTypes.DELETE_COMPLETED, payload: employee})
}

export const actionDeleteEmployees = (employees: Employee[]) => {
	AppStore.dispatch({type: EmployeesActionTypes.DELETE_MULTIPLE_REQUEST, payload: employees})
}

export const actionDeleteEmployeesCompleted = (employees: Employee[]) => {
	AppStore.dispatch({type: EmployeesActionTypes.DELETE_MULTIPLE_COMPLETED, payload: employees})
}
